import { SensitivityEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const create = async (data: any): Promise<any> =>
  APIManager.sendPost(SensitivityEnds.CREATE, data, true, {}, {}, axios);

const getAll = async (): Promise<any> =>
  APIManager.sendGet(SensitivityEnds.GET_ALL, true, {}, {}, axios);

const deleteType = async (id: string): Promise<any> =>
  APIManager.sendDelete(SensitivityEnds.DELETE(id), true, {}, {}, axios);

const update = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(SensitivityEnds.UPDATE(id), data, true, {}, {}, axios);

export const SensitivityService = {
  create,
  getAll,
  deleteType,
  update,
};
